import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  InputGroup,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import { getAllCountryData } from "../../../redux/actions/countryCityActions";
import {
  get_merchant_list,
  get_merchant_details_id,
} from "../../../redux/actions/merchantActions";
import { getPayoutDropdownList } from "../../../redux/actions/payoutActions";
import {
  add_contract,
  getContractDetails,
  update_contract,
  clone_contract,
  clone_contract_non_executed,
  ContractType,
} from "../../../redux/actions/contractActions";
import { getSalesPersons } from "../../../redux/actions/salesPersonActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import loader from "../../../style/loader/loader.scss";
import auth from "../../../services/auth";

import AdditionalPrice from "./AdditionalPrice";
import Attributes from "./Attributes";
import { aclUtil } from "../../util";
import NumberFormat from "react-number-format";
let xCoordinate = {},
  yCoordinate = {};

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  countries: PropTypes.array.isRequired,
  get_merchant_list: PropTypes.func.isRequired,
  getContractDetails: PropTypes.func.isRequired,
  update_contract: PropTypes.func.isRequired,
  clone_contract: PropTypes.func.isRequired,
  clone_contract_non_executed: PropTypes.func.isRequired,
  get_merchant_details_id: PropTypes.func.isRequired,
};

let cityItems = [];
let isLoading = "false";
let userinfo = "";

let priceIndex = 0;
let form = [];
let offerTitle = [],
  r_offerTitle = [],
  french_offerTitle = [],
  expirationMonth = [],
  expirationDate = [],
  minQuantity = [],
  activateQuantity = [],
  skuCode = [],
  maxPerCustomer = [],
  percentageOff = [],
  maxAvailable = [],
  retailPrice = [],
  offerPrice = [],
  remittance = [],
  stockmanage = [],
  incrementalRedemption = [],
  maxAsGift = [],
  attributeData = [],
  BillingPeriodOptions = [],
  RecurringretailPrice = [],
  RecurringofferPrice = [],
  RecurringBillingCycle = [],
  Days = [],
  contractID = [];
let additionalPriceDetail = [],
  contractIdParams,
  contractTypeParams,
  contract,
  matrixData = [],
  vouchers = [];

class AddContract extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      menuKey: "ADD_CONTRACT",
      path: ["Home", "Manage Contract", "Add New"],
      links: ["home", "contractList", "addContract"],
      startDate: moment(),
      countryData: [],
      statesName: [],
      citiesName: [],
      stateList: [],
      contractID: "",
      showoutstock:true,
      paidcart: "",
      cityID: "",
      offerTitle: "",
      french_offerTitle: "",
      percentageOff: "",
      maxAvailable: "",
      retailPrice: "",
      offerPrice: "",
      remittance: "",
      maxPerCustomer: "",
      maxAsGift: "",
      incrementalRedemption: "0",
      expirationMonth: "",
      expirationDate: "",
      minQuantity: "1",
      activateQuantity: "",
      skuCode: "",
      merchantID: "",
      merchantLegalName: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      country: "",
      zip: "",
      phone: "",
      stockmanage:"",

      contactName: "",
      contactPhone: "",
      contactEmail: "",
      notes: "",
      termsAndConditions: "",
      french_termsAndConditions: "",
      redeemedAtCall: "0",
      shipable: "0",
      redemptionCodeReq: "0",
      vouchersBeIssued: "instantly",
      alertMessage: "",
      countryName: "United States",
      coupoOption: false,
      service: "",
      pricing: "",
      creditCardType: "",
      creditCardNumber: "",
      cardExpirationDate: "",
      securityNumber: "",
      affiliateOption: false,
      affiliatePurchaseUrl: "",
      paymentType: "Fixed Fee",
      paymentAmount: "",
      paymentReceived: "0",
      paymentAmountReceived: "",
      paymentAmountReceivedStatus: false,
      contractType: 1,
      disabled: false,
      submitValue: "Save",
      show: false,
      changeDate: false,
      salesManagerID: "",
      salespersonlist: [],
      priceIndex: [],
      attributeStatus: false,
      merchantOffer: "",
      attributes: [],
      clearAttributes: false,
      payoutList: "",
      deatil: "",
      max_overall: "",
      multi_lang: "no",
      addCity: "",
      addState: "",
      hideMsg: false,
      ProposalTypes: [1, 2, 3, 4, 5, 6, 7, 8],
      BillingPeriodOptions: "Yearly",
      RecurringretailPrice: "",
      RecurringofferPrice: "",
      RecurringBillingCycle: "",
      Days: "0",
      RecurringretailPriceError: "",
      RecurringofferPriceError: "",
      RecurringBillingCycleError: "",
      DaysError: "",
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdateDates = this.handleUpdateDates.bind(this);
    this.handleChangeMerchant = this.handleChangeMerchant.bind(this);
    this.handleChangeContract = this.handleChangeContract.bind(this);
    this.handlePaymentReceived = this.handlePaymentReceived.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.onSelectedState = this.onSelectedState.bind(this);
    this.addPricingDetail = this.addPricingDetail.bind(this);
  }
  /*
   * Start multiple price management
   */

  AttributeStatus = () => {
    this.setState({ attributeStatus: true });
  };
  addPricingDetail = (e) => {
   this.setState({showoutstock:false});

    priceIndex = priceIndex + 1;
    form[priceIndex] = (
      <AdditionalPrice
        removePriceDetail={this.removePriceDetail}
        indexKey={priceIndex}
        affiliateOption={this.state.affiliateOption}
        contractType={this.state.contractType}
        handleOfferChange={this.handleOfferChange}
        handleFrenchOfferChange={this.handleFrenchOfferChange}
        handleexpirationMonthChange={this.handleexpirationMonthChange}
        handleexpirationDateChange={this.handleexpirationDateChange}
        handleminQuantityChange={this.handleminQuantityChange}
        handleActiveQuantityChange={this.handleActiveQuantityChange}
        handleskuCodeChange={this.handleskuCodeChange}
        handlemaxPerCustomerChange={this.handlemaxPerCustomerChange}
        handlepercentageOffChange={this.handlepercentageOffChange}
        handlemaxAvailableChange={this.handlemaxAvailableChange}
        handleretailPriceChange={this.handleretailPriceChange}
        handleofferPriceChange={this.handleofferPriceChange}
        handleremittanceChange={this.handleremittanceChange}
        handleincrementalRedemptionChange={
          this.handleincrementalRedemptionChange
        }
        handleGenerateVoucher={this.handleGenerateVoucher}
        handlemaxAsGiftChange={this.handlemaxAsGiftChange}
        handleBillingPeriodOptionsChange={this.handleBillingPeriodOptionsChange}
        handleDaysChange={this.handleDaysChange}
        handleRecurringretailPriceChange={this.handleRecurringretailPriceChange}
        handleRecurringofferPriceChange={this.handleRecurringofferPriceChange}
        handleRecurringBillingCycleChange={
          this.handleRecurringBillingCycleChange
        }
        attributeData={this.attributeData}
        priceData=""
        validationError={this.state.additionalError}
        matrixData={this.matrixData}
        key={Math.random()}
      />
    );
    this.setState({ priceIndex: form });
  };

  editPricingDetail = (data) => {
    priceIndex = priceIndex + 1;
    form[priceIndex] = (
      <AdditionalPrice
        key={Math.random()}
        removePriceDetail={this.removePriceDetail}
        indexKey={priceIndex}
        affiliateOption={this.state.affiliateOption}
        handleOfferChange={this.handleOfferChange}
        contractType={this.state.contractType}
        handleFrenchOfferChange={this.handleFrenchOfferChange}
        handleexpirationMonthChange={this.handleexpirationMonthChange}
        handleexpirationDateChange={this.handleexpirationDateChange}
        handleminQuantityChange={this.handleminQuantityChange}
        handleActiveQuantityChange={this.handleActiveQuantityChange}
        handleskuCodeChange={this.handleskuCodeChange}
         handleStockChange={this.handleStockChange}
        handlemaxPerCustomerChange={this.handlemaxPerCustomerChange}
        handlepercentageOffChange={this.handlepercentageOffChange}
        handlemaxAvailableChange={this.handlemaxAvailableChange}
        handleretailPriceChange={this.handleretailPriceChange}
        handleofferPriceChange={this.handleofferPriceChange}
        handleStockChange={this.handleStockChange}
        handleremittanceChange={this.handleremittanceChange}
        handleincrementalRedemptionChange={
          this.handleincrementalRedemptionChange
        }
        handleGenerateVoucher={this.handleGenerateVoucher}
        handlemaxAsGiftChange={this.handlemaxAsGiftChange}
        handleBillingPeriodOptionsChange={this.handleBillingPeriodOptionsChange}
        handleDaysChange={this.handleDaysChange}
        handleRecurringretailPriceChange={this.handleRecurringretailPriceChange}
        handleRecurringofferPriceChange={this.handleRecurringofferPriceChange}
        handleRecurringBillingCycleChange={
          this.handleRecurringBillingCycleChange
        }
        attributeData={this.attributeData}
        priceData={data}
        handleUpdate={this.handleUpdate}
        validationError={this.state.additionalError}
        matrixData={this.matrixData}
        key={Math.random()}
      />
    );
    maxAvailable[priceIndex] = data.maxAvailable;
    r_offerTitle[priceIndex] = data.offerTitle;
    this.setState({ priceIndex: form });
  };

  handleUpdate = (field, value, index, contractID) => {
    let newIdx = index - 1;

    if (field == "attributes") {
      field = "attribute";
    }
    if (field == "maxAvailable") {
      maxAvailable[index] = value;
    }
    if (field == "expirationDate") {
      expirationDate[index] = value;
    }

    const newContract = this.state.contract.map((data, pidx) => {
      if (newIdx !== pidx) return data;
      return { ...data, [field]: value };
    });
    this.setState({ contract: newContract });
  };

  onChangeExpirationDate = (date) => {
    this.setState({ expirationDate: date });
    this.handleexpirationDateChange(date, 0);
  };

  handleChangeAditionalPrice = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.name == "offerTitle") {
      this.handleOfferChange(e.target.value, 0);
    }
    if (e.target.name == "french_offerTitle") {
      this.handleFrenchOfferChange(e.target.value, 0);
    }
    if (e.target.name == "expirationMonth") {
      this.handleexpirationMonthChange(e.target.value, 0);
    }
    if (e.target.name == "expirationDate") {
      this.handleexpirationDateChange(e.target.value, 0);
    }
    if (e.target.name == "minQuantity") {
      this.handleminQuantityChange(e.target.value, 0);
    }

    if (e.target.name == "activateQuantity") {
      this.handleActiveQuantityChange(e.target.value, 0);
    }

    if (e.target.name == "skuCode") {
      this.handleskuCodeChange(e.target.value, 0);
    }
    if (e.target.name == "maxPerCustomer") {
      this.handlemaxPerCustomerChange(e.target.value, 0);
    }
    if (e.target.name == "percentageOff") {
      this.handlepercentageOffChange(e.target.value, 0);
      const hideMsg = e.target.value > 100 ? true : false;
      this.setState({ hideMsg: hideMsg });
    }
    if (e.target.name == "maxAvailable") {
      this.handlemaxAvailableChange(e.target.value, 0);
    }
    if (e.target.name == "retailPrice") {
      this.handleretailPriceChange(e.target.value, 0);
    }
    if (e.target.name == "offerPrice") {
      this.handleofferPriceChange(e.target.value, 0);
    }

    if (e.target.name == "stockmanage") {
     // alert(e.target.value);
      this.handleStockChange(e.target.value, 0);
    }
    if (e.target.name == "remittance") {
      this.handleremittanceChange(e.target.value, 0);
    }
    if (e.target.name == "incrementalRedemption") {
      this.handleincrementalRedemptionChange(e.target.value, 0);
      if (e.target.value == 0) {
        this.setState({ vouchers: "" });
        this.handleGenerateVoucher("", 0);
      }
    }
    if (e.target.name == "vouchers") {
      this.handleGenerateVoucher(e.target.value, 0);
    }

    if (e.target.name == "maxAsGift") {
      this.handlemaxAsGiftChange(e.target.value, 0);
    }

    if (e.target.name == "RecurringBillingCycle") {
      this.handleRecurringBillingCycleChange(e.target.value, 0);
    }

    if (e.target.name == "Days") {
      this.handleDaysChange(e.target.value, 0);
    }

    if (e.target.name == "RecurringofferPrice") {
      this.handleRecurringofferPriceChange(e.target.value, 0);
    }

    if (e.target.name == "RecurringretailPrice") {
      this.handleRecurringretailPriceChange(e.target.value, 0);
    }

    if (e.target.name == "BillingPeriodOptions") {
      this.handleBillingPeriodOptionsChange(e.target.value, 0);
    }

    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    if (e.target.name === "expirationMonth") {
      if (this.state.expirationMonthError !== "") {
        this.setState({ expirationDateError: "", expirationMonthError: "" });
      }
    }
    if (e.target.name === "expirationDate") {
      if (this.state.expirationDateError !== "") {
        this.setState({ expirationDateError: "", expirationMonthError: "" });
      }
    }
  };

  removePriceDetail = (id, contractID) => {
    if (contractID != "") {
      let newID = id - 1;
      let contractData = this.state.contract;
      delete contractData[newID];
      this.setState({ contract: contractData });

      let priceIndex = this.state.priceIndex;
      delete priceIndex[id];
      this.setState({ priceIndex: priceIndex });
    } else {
      let priceIndex = this.state.priceIndex;
      delete priceIndex[id];
      this.setState({ priceIndex: priceIndex });

      delete offerTitle[id];
      delete french_offerTitle[id];
      delete expirationMonth[id];
      delete expirationDate[id];
      delete minQuantity[id];
      delete activateQuantity[id];
      delete skuCode[id];
      delete maxPerCustomer[id];
      delete percentageOff[id];
      delete maxAvailable[id];
      delete retailPrice[id];
      delete offerPrice[id];
      delete remittance[id];
      delete incrementalRedemption[id];
      delete maxAsGift[id];
      delete priceIndex[id];
      delete BillingPeriodOptions[id];
      delete RecurringretailPrice[id];
      delete RecurringofferPrice[id];
      delete RecurringBillingCycle[id];
      delete Days[id];
    }
  };

  handleContractIDChange = (data, idx) => {
    contractID[idx] = data;
  };

  handleFrenchOfferChange = (offerTitleData, idx) => {
    french_offerTitle[idx] = offerTitleData;
  };

  handleOfferChange = (offerTitleData, idx) => {
    offerTitle[idx] = offerTitleData;
    r_offerTitle[idx] = offerTitleData;
  };
  handleexpirationMonthChange = (expirationMonthData, idx) => {
    expirationMonth[idx] = expirationMonthData;
  };
  handleexpirationDateChange = (expirationDateData, idx) => {
    expirationDate[idx] = expirationDateData;
  };

  handleminQuantityChange = (minQuantityData, idx) => {
    minQuantity[idx] = minQuantityData;
  };

  handleActiveQuantityChange = (activateQuantitydata, idx) => {
    activateQuantity[idx] = activateQuantitydata;
  };

  handleskuCodeChange = (skuCodeData, idx) => {
    skuCode[idx] = skuCodeData;
  };
  handlemaxPerCustomerChange = (maxPerCustomerData, idx) => {
    maxPerCustomer[idx] = maxPerCustomerData;
  };
  handlepercentageOffChange = (percentageOffData, idx) => {
    percentageOff[idx] = percentageOffData;
  };
  handlemaxAvailableChange = (maxAvailableData, idx) => {
    maxAvailable[idx] = maxAvailableData;
  };
  handleretailPriceChange = (retailPriceData, idx) => {
    retailPrice[idx] = retailPriceData;
  };
  handleofferPriceChange = (offerPriceData, idx) => {
    offerPrice[idx] = offerPriceData;
  };
   handleStockChange = (stockmanageData, idx) => {
    stockmanage[idx] = stockmanageData;
  };
  handleremittanceChange = (remittanceData, idx) => {
    remittance[idx] = remittanceData;
  };
  handleincrementalRedemptionChange = (incrementalRedemptionData, idx) => {
    incrementalRedemption[idx] = incrementalRedemptionData;
  };
  handleGenerateVoucher = (vouchersData, idx) => {
    vouchers[idx] = vouchersData;
  };

  handlemaxAsGiftChange = (maxAsGiftData, idx) => {
    maxAsGift[idx] = maxAsGiftData;
    let result = maxAsGift.some((el) => el > 0);
    if (result) {
      this.setState({ redeemedAtCall: 1 });
    } else {
      this.setState({ redeemedAtCall: 0 });
    }
  };

  handleBillingPeriodOptionsChange = (BillingPeriodOptionsData, idx) => {
    BillingPeriodOptions[idx] = BillingPeriodOptionsData;
  };

  handleDaysChange = (DaysData, idx) => {
    Days[idx] = DaysData;
  };

  handleRecurringretailPriceChange = (RecurringretailPriceData, idx) => {
    RecurringretailPrice[idx] = RecurringretailPriceData;
  };

  handleRecurringofferPriceChange = (RecurringofferPriceData, idx) => {
    RecurringofferPrice[idx] = RecurringofferPriceData;
  };

  handleRecurringBillingCycleChange = (RecurringBillingCycleData, idx) => {
    RecurringBillingCycle[idx] = RecurringBillingCycleData;
  };

  attributeData = (data, idx) => {
    if (idx == 0) {
      this.setState({ attributes: data });
    }
    attributeData[idx] = data;
  };

  matrixData = (data, idx) => {
    matrixData[idx] = data;
  };

  /*
   * End multiple price management
   */

  handleUpdateDates(date) {
    this.setState({ disabled: false });
    const dates = moment();
    if (date) {
      const dates = date;
      this.setState({
        startDate: dates,
        changeDate: true,
        expirationMonthError: "",
        expirationDateError: "",
      });
    } else {
      this.setState({
        changeDate: false,
      });
    }
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handlePaymentReceived(e) {
    this.setState({ disabled: false });
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.value === "1") {
      this.setState({ paymentAmountReceivedStatus: true });
    } else {
      this.setState({ paymentAmountReceivedStatus: false });
    }
  }

  handleChangeMerchant(e) {
    this.setState({ disabled: false });
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
    this.setState({
      merchantLegalName: "",
      address1: "",
      address2: "",
      phone: "",
      contactEmail: "",
      contactPhone: "",
      contactName: "",
      zip: "",
      city: "",
      country: "",
      cityID: "",
      state: "",
      addState: "",
      addCity: "",
    });
    this.props.get_merchant_details_id({ merchantId: e.target.value });
  }

  handleChangeContract(e) {
    this.setState({ disabled: false });
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
    if (e.target.value === "6") {
      this.setState({ coupoOption: true });
      this.setState({ affiliateOption: false });
    } else if (e.target.value === "7") {
      this.setState({ coupoOption: false });
      this.setState({ affiliateOption: true });
    } else {
      this.setState({ coupoOption: false });
      this.setState({ affiliateOption: false });
    }
  }

  // Handle input onchange
  handleChange(e) {
    this.setState({ disabled: false });
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    xCoordinate = {};
    yCoordinate = {};
    let checksMaxAvailable = true;
    maxAvailable.map((data, index) => {
      if (typeof data == "undefined" || data == "" || data == null) {
        checksMaxAvailable = false;
      }
    });
    let totalMaxAvailable = 0;
    if (
      maxAvailable.length == 0 ||
      typeof maxAvailable[0] == "undefined" ||
      maxAvailable.length != offerTitle.length
    ) {
      checksMaxAvailable = false;
    }
    maxAvailable.map((data, index) => {
      if (data !== "" && data !== null) {
        totalMaxAvailable = parseInt(totalMaxAvailable) + parseInt(data);
      }
    });
    if (!this.state.max_overall) {
      maxAvailable.map((data, index) => {
        if (data == "") {
          this.props.renderAlert(
            "warning",
            "All max available field is required if overall quantity value is empty."
          );
          isError = true;
          window.scrollTo(0, 0);
        }
      });
    }

    if (checksMaxAvailable == false) {
      if (
        this.state.max_overall &&
        parseInt(this.state.max_overall) < parseInt(totalMaxAvailable)
      ) {
        this.props.renderAlert(
          "warning",
          "Max overall must be greater than or equal to total max available."
        );
        isError = true;
        window.scrollTo(0, 0);
      } else if (
        !this.state.max_overall &&
        maxAvailable.length != r_offerTitle.length &&
        totalMaxAvailable > 0
      ) {
        this.props.renderAlert(
          "warning",
          "All max available field is required if overall quantity value is empty."
        );
        isError = true;
        window.scrollTo(0, 0);
      }
    } else {
      if (
        this.state.max_overall &&
        (parseInt(this.state.max_overall) != parseInt(totalMaxAvailable) ||
          parseInt(this.state.max_overall) < parseInt(totalMaxAvailable))
      ) {
        this.props.renderAlert(
          "warning",
          "Max overall must be greater than or equal to total max available."
        );
        isError = true;
        window.scrollTo(0, 0);
      }
    }

    if (this.state.merchantOffer.length === 0) {
      isError = true;
      this.setState({ merchantOfferError: "red" });
      if (xCoordinate.key !== "formmerchantTitle") {
        let x =
          window.scrollX +
          document.querySelector("#formmerchantTitle").getBoundingClientRect()
            .left;
        let y =
          window.scrollY +
          document.querySelector("#formmerchantTitle").getBoundingClientRect()
            .top -
          89;
        xCoordinate["formmerchantTitle"] = x;
        yCoordinate["formmerchantTitle"] = y;
      }
    }

    if (this.state.offerTitle.length === 0) {
      isError = true;
      this.setState({ offerTitleError: "red" });
      if (xCoordinate.key !== "formOfferTitle") {
        let x =
          window.scrollX +
          document.querySelector("#formOfferTitle").getBoundingClientRect()
            .left;
        let y =
          window.scrollY +
          document.querySelector("#formOfferTitle").getBoundingClientRect()
            .top -
          89;
        xCoordinate["formOfferTitle"] = x;
        yCoordinate["formOfferTitle"] = y;
      }
    }
    if (this.state.affiliateOption === true) {
      if (
        this.state.percentageOff.length === 0 ||
        this.state.percentageOff > 100
      ) {
        isError = true;
        this.setState({
          percentageOffError: "red",
          limitMessage: " (Please input between 0 to 100 )",
        });
        if (xCoordinate.key !== "formPercentageOff") {
          let x =
            window.scrollX +
            document.querySelector("#formPercentageOff").getBoundingClientRect()
              .left;
          let y =
            window.scrollY +
            document.querySelector("#formPercentageOff").getBoundingClientRect()
              .top -
            89;
          xCoordinate["formPercentageOff"] = x;
          yCoordinate["formPercentageOff"] = y;
        }
      }
    }
    if (this.state.affiliateOption === false) {
      if (this.state.retailPrice.length === 0) {
        isError = true;
        this.setState({ retailPriceError: "red" });
        if (xCoordinate.key !== "formRetailPrice") {
          let x =
            window.scrollX +
            document.querySelector("#formRetailPrice").getBoundingClientRect()
              .left;
          let y =
            window.scrollY +
            document.querySelector("#formRetailPrice").getBoundingClientRect()
              .top -
            89;
          xCoordinate["formRetailPrice"] = x;
          yCoordinate["formRetailPrice"] = y;
        }
      }
      if (this.state.offerPrice.length === 0) {
        isError = true;
        this.setState({ offerPriceError: "red" });
        if (xCoordinate.key !== "formOfferPrice") {
          let x =
            window.scrollX +
            document.querySelector("#formOfferPrice").getBoundingClientRect()
              .left;
          let y =
            window.scrollY +
            document.querySelector("#formOfferPrice").getBoundingClientRect()
              .top -
            89;
          xCoordinate["formOfferPrice"] = x;
          yCoordinate["formOfferPrice"] = y;
        }
      }
    }

    if (!this.state.merchantID) {
      isError = true;
      this.setState({ merchantIDError: "red" });
      if (xCoordinate.key !== "formMerchantID") {
        let x =
          window.scrollX +
          document.querySelector("#formMerchantID").getBoundingClientRect()
            .left;
        let y =
          window.scrollY +
          document.querySelector("#formMerchantID").getBoundingClientRect()
            .top -
          89;
        xCoordinate["formMerchantID"] = x;
        yCoordinate["formMerchantID"] = y;
      }
    }

    if (!this.state.merchantLegalName) {
      isError = true;
      this.setState({ merchantLegalNameError: "red" });
      if (xCoordinate.key !== "formmerchantLegalName") {
        let x =
          window.scrollX +
          document
            .querySelector("#formmerchantLegalName")
            .getBoundingClientRect().left;
        let y =
          window.scrollY +
          document
            .querySelector("#formmerchantLegalName")
            .getBoundingClientRect().top -
          89;
        xCoordinate["formmerchantLegalName"] = x;
        yCoordinate["formmerchantLegalName"] = y;
      }
    }

    if (this.state.expirationMonth === "" && this.state.expirationDate === "") {
      isError = true;
      this.setState({
        expirationMonthError: "red",
        expirationDateError: "red",
      });
      if (xCoordinate.key !== "formExpirationMonth") {
        let x =
          window.scrollX +
          document.querySelector("#formExpirationMonth").getBoundingClientRect()
            .left;
        let y =
          window.scrollY +
          document.querySelector("#formExpirationMonth").getBoundingClientRect()
            .top -
          89;
        xCoordinate["formExpirationMonth"] = x;
        yCoordinate["formExpirationMonth"] = y;
      }
      if (xCoordinate.key !== "formExpirationDate") {
        let x =
          window.scrollX +
          document.querySelector("#formExpirationMonth").getBoundingClientRect()
            .left;
        let y =
          window.scrollY +
          document.querySelector("#formExpirationMonth").getBoundingClientRect()
            .top -
          89;
        xCoordinate["formExpirationMonth"] = x;
        yCoordinate["formExpirationMonth"] = y;
      }
    }

    if (this.state.affiliateOption === false) {
      if (!this.state.remittance) {
        isError = true;
        this.setState({ remittanceError: "red" });
        if (xCoordinate.key !== "formMinQuantity") {
          let x =
            window.scrollX +
            document.querySelector("#formMinQuantity").getBoundingClientRect()
              .left;
          let y =
            window.scrollY +
            document.querySelector("#formMinQuantity").getBoundingClientRect()
              .top -
            89;
          xCoordinate["formMinQuantity"] = x;
          yCoordinate["formMinQuantity"] = y;
        }
      }

      if (!this.state.payment_term_id) {
        isError = true;
        this.setState({ payment_term_idError: "red" });
      }

      if (this.state.maxAsGift === "") {
        isError = true;
        this.setState({ maxAsGiftError: "red" });
        if (xCoordinate.key !== "formMaxAsGift") {
          let x =
            window.scrollX +
            document.querySelector("#formMaxAsGift").getBoundingClientRect()
              .left;
          let y =
            window.scrollY +
            document.querySelector("#formMaxAsGift").getBoundingClientRect()
              .top -
            89;
          xCoordinate["formMaxAsGift"] = x;
          yCoordinate["formMaxAsGift"] = y;
        }
      }
    }

    if (this.state.contractType == "9") {
      if (this.state.RecurringretailPrice === "") {
        isError = true;
        this.setState({ RecurringretailPriceError: "red" });
        if (xCoordinate.key !== "formRecurringretailPrice") {
          let x =
            window.scrollX +
            document
              .querySelector("#formRecurringretailPrice")
              .getBoundingClientRect().left;
          let y =
            window.scrollY +
            document
              .querySelector("#formRecurringretailPrice")
              .getBoundingClientRect().top -
            89;
          xCoordinate["formRecurringretailPrice"] = x;
          yCoordinate["formRecurringretailPrice"] = y;
        }
      }

      if (this.state.RecurringofferPrice === "") {
        isError = true;
        this.setState({ RecurringofferPriceError: "red" });
        if (xCoordinate.key !== "formRecurringofferPrice") {
          let x =
            window.scrollX +
            document
              .querySelector("#formRecurringofferPrice")
              .getBoundingClientRect().left;
          let y =
            window.scrollY +
            document
              .querySelector("#formRecurringofferPrice")
              .getBoundingClientRect().top -
            89;
          xCoordinate["formRecurringofferPrice"] = x;
          yCoordinate["formRecurringofferPrice"] = y;
        }
      }

      if (
        this.state.RecurringBillingCycle === "" ||
        this.state.RecurringBillingCycle < 2
      ) {
        isError = true;
        this.setState({ RecurringBillingCycleError: "red" });
        if (xCoordinate.key !== "formRecurringBillingCycle") {
          let x =
            window.scrollX +
            document
              .querySelector("#formRecurringBillingCycle")
              .getBoundingClientRect().left;
          let y =
            window.scrollY +
            document
              .querySelector("#formRecurringBillingCycle")
              .getBoundingClientRect().top -
            89;
          xCoordinate["formRecurringBillingCycle"] = x;
          yCoordinate["formRecurringBillingCycle"] = y;
        }
      }

      if (
        this.state.BillingPeriodOptions == "Days" &&
        (this.state.Days === "" || this.state.Days < 7)
      ) {
        isError = true;
        this.setState({ DaysError: "red" });
        if (xCoordinate.key !== "formDays") {
          let x =
            window.scrollX +
            document.querySelector("#formDays").getBoundingClientRect().left;
          let y =
            window.scrollY +
            document.querySelector("#formDays").getBoundingClientRect().top -
            89;
          xCoordinate["formDays"] = x;
          yCoordinate["formDays"] = y;
        }
      }
    }

    return isError;
  };

  additionalPrice = () => {
    additionalPriceDetail = [];
    let constAdditionalData;
    // contractID
    if (contractIdParams == "") {
      for (let i = 0; i < r_offerTitle.length; i++) {
        if (
          typeof r_offerTitle[i] != "undefined" &&
          r_offerTitle[i] != "" &&
          typeof offerTitle[i] != "undefined" &&
          offerTitle[i] != ""
        ) {
          constAdditionalData = {
            offerTitle: offerTitle[i] ? offerTitle[i] : "",
            french_offerTitle: french_offerTitle[i] ? french_offerTitle[i] : "",
            max_overall: this.state.max_overall,
            expirationMonth: expirationMonth[i] ? expirationMonth[i] : "",
            expirationDate: expirationDate[i]
              ? moment(expirationDate[i])
                  .format()
                  .replace(/-/g, "/")
                  .replace(/T.+/, "")
              : "",
            minQuantity: minQuantity[i] ? minQuantity[i] : "",
            activateQuantity: activateQuantity[i] ? activateQuantity[i] : "",
            skuCode: skuCode[i] ? skuCode[i] : "",
            maxPerCustomer: maxPerCustomer[i] ? maxPerCustomer[i] : "",
            maxAvailable: maxAvailable[i] ? maxAvailable[i] : "",
            stockmanage: stockmanage[i] ? stockmanage[i] : "",
            retailPrice: retailPrice[i] ? retailPrice[i] : "",
            offerPrice: offerPrice[i] ? offerPrice[i] : "",
            remittance: remittance[i] ? remittance[i] : "",
            incrementalRedemption: incrementalRedemption[i]
              ? incrementalRedemption[i]
              : "",
            vouchers: vouchers[i] ? vouchers[i] : "",
            maxAsGift: maxAsGift[i] ? maxAsGift[i] : "",
            BillingPeriodOptions: BillingPeriodOptions[i]
              ? BillingPeriodOptions[i]
              : "",
            RecurringretailPrice: RecurringretailPrice[i]
              ? RecurringretailPrice[i]
              : "",
            RecurringofferPrice: RecurringofferPrice[i]
              ? RecurringofferPrice[i]
              : "",
            RecurringBillingCycle: RecurringBillingCycle[i]
              ? RecurringBillingCycle[i]
              : "",
            Days: Days[i] ? Days[i] : "",
            attributes: attributeData[i] ? attributeData[i] : [],
            metrix: matrixData[i] ? matrixData[i] : "",
          };
          additionalPriceDetail.push(constAdditionalData);
        }
      }
    } else {
      for (let i = 0; i < offerTitle.length; i++) {
        if (typeof offerTitle[i] != "undefined" && offerTitle[i] != "") {
          constAdditionalData = {
            contractID: contractID[i] ? contractID[i] : "",
            offerTitle: offerTitle[i] ? offerTitle[i] : "",
            french_offerTitle: french_offerTitle[i] ? french_offerTitle[i] : "",
            max_overall: this.state.max_overall,
            expirationMonth: expirationMonth[i] ? expirationMonth[i] : "",
            expirationDate: expirationDate[i]
              ? moment(expirationDate[i])
                  .format()
                  .replace(/-/g, "/")
                  .replace(/T.+/, "")
              : "",
            minQuantity: minQuantity[i] ? minQuantity[i] : "",
            activateQuantity: activateQuantity[i] ? activateQuantity[i] : "",
            skuCode: skuCode[i] ? skuCode[i] : "",
            maxPerCustomer: maxPerCustomer[i] ? maxPerCustomer[i] : "",
            percentageOff: percentageOff[i] ? percentageOff[i] : "",
            maxAvailable: maxAvailable[i] ? maxAvailable[i] : "",
            retailPrice: retailPrice[i] ? retailPrice[i] : "",
            offerPrice: offerPrice[i] ? offerPrice[i] : "",
            stockmanage: stockmanage[i] ? stockmanage[i] : "",


            remittance: remittance[i] ? remittance[i] : "",
            incrementalRedemption: incrementalRedemption[i]
              ? incrementalRedemption[i]
              : "",
            vouchers: vouchers[i] ? vouchers[i] : "",
            maxAsGift: maxAsGift[i] ? maxAsGift[i] : "",
            BillingPeriodOptions: BillingPeriodOptions[i]
              ? BillingPeriodOptions[i]
              : "",
            RecurringretailPrice: RecurringretailPrice[i]
              ? RecurringretailPrice[i]
              : "",
            RecurringofferPrice: RecurringofferPrice[i]
              ? RecurringofferPrice[i]
              : "",
            RecurringBillingCycle: RecurringBillingCycle[i]
              ? RecurringBillingCycle[i]
              : "",
            Days: Days[i] ? Days[i] : "",
            attributes: attributeData[i] ? attributeData[i] : [],
            metrix: matrixData[i] ? matrixData[i] : "",
          };
          additionalPriceDetail.push(constAdditionalData);
        }
      }
      if (this.state.contract) {
        this.state.contract.map((data, i) => {
          data.expirationDate = data.expirationDate
            ? moment(data.expirationDate)
                .format()
                .replace(/-/g, "/")
                .replace(/T.+/, "")
            : "";
          if (data.attribute) {
            data.max_overall = this.state.max_overall;
            data.attributes = data.attribute ? data.attribute : [];
            delete data["attribute"];
            additionalPriceDetail.push(data);
          } else {
            additionalPriceDetail.push(data);
          }
        });
      }
    }
    this.setState({ deatil: additionalPriceDetail });
    return additionalPriceDetail;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    const additionalPrice = this.additionalPrice();
    if (!err) {
      this.setState({ disabled: true });
      // const date = this.state.expirationDate ? this.state.expirationDate : null;
      if (this.state.contractID !== "") {
        if (contractIdParams !== "" && contractTypeParams == "edit") {
          const postData = {
            proposal_type: this.state.contractType,
            affiliatePurchaseUrl: this.state.affiliatePurchaseUrl,
            paymentType: this.state.paymentType,
            paymentAmount: this.state.paymentAmount,
            paymentReceived: this.state.paymentReceived,
            paymentAmountReceived: this.state.paymentAmountReceived,
            service: this.state.service,
            price: this.state.pricing,
            creditCardType: this.state.creditCardType,
            creditCardNumber: this.state.creditCardNumber,
            cardExpirationDate: this.state.cardExpirationDate,
            securityNumber: this.state.securityNumber,
            cityID: this.state.cityID,
            merchantOffer: this.state.merchantOffer,
            detail: additionalPrice,
            merchantID: this.state.merchantID,
            merchantLegalName: this.state.merchantLegalName,
            address1: this.state.address1,
            address2: this.state.address2,
            city: this.state.city ? this.state.city : "",
            state: this.state.state ? this.state.state : "",
            country: this.state.country ? this.state.country : "",
            addState: this.state.addState ? this.state.addState : "",
            addCity: this.state.addCity ? this.state.addCity : "",
            zip: this.state.zip,
            phone: this.state.phone,
            contactName: this.state.contactName,
            contactPhone: this.state.contactPhone,
            contactEmail: this.state.contactEmail,
            notes: this.state.notes,
            termsAndConditions: this.state.termsAndConditions,
            french_termsAndConditions: this.state.french_termsAndConditions,
            redeemedAtCall: this.state.redeemedAtCall,
            shipable: this.state.shipable,
            redemptionCodeReq: this.state.redemptionCodeReq,
            vouchersBeIssued: this.state.vouchersBeIssued,
            salesManagerID: this.state.salesManagerID,
            payment_term_id: this.state.payment_term_id,
            activateQuantity: this.state.activateQuantity,
          };
          this.props.update_contract(postData);
        } else if (contractIdParams !== "" && contractTypeParams == "clone") {
          const postData = {
            cloneContractID: this.state.contractID,
            proposal_type: this.state.contractType,
            affiliatePurchaseUrl: this.state.affiliatePurchaseUrl,
            paymentType: this.state.paymentType,
            paymentAmount: this.state.paymentAmount,
            paymentReceived: this.state.paymentReceived,
            paymentAmountReceived: this.state.paymentAmountReceived,
            service: this.state.service,
            price: this.state.pricing,
            creditCardType: this.state.creditCardType,
            creditCardNumber: this.state.creditCardNumber,
            cardExpirationDate: this.state.cardExpirationDate,
            securityNumber: this.state.securityNumber,
            cityID: this.state.cityID,
            merchantOffer: this.state.merchantOffer,
            detail: additionalPrice,
            merchantID: this.state.merchantID,
            merchantLegalName: this.state.merchantLegalName,
            address1: this.state.address1,
            address2: this.state.address2,
            city: this.state.city ? this.state.city : "",
            state: this.state.state ? this.state.state : "",
            country: this.state.country ? this.state.country : "",
            addState: this.state.addState ? this.state.addState : "",
            addCity: this.state.addCity ? this.state.addCity : "",
            zip: this.state.zip,
            phone: this.state.phone,
            contactName: this.state.contactName,
            contactPhone: this.state.contactPhone,
            contactEmail: this.state.contactEmail,
            notes: this.state.notes,
            termsAndConditions: this.state.termsAndConditions,
            french_termsAndConditions: this.state.french_termsAndConditions,
            redeemedAtCall: this.state.redeemedAtCall,
            shipable: this.state.shipable,
            redemptionCodeReq: this.state.redemptionCodeReq,
            vouchersBeIssued: this.state.vouchersBeIssued,
            salesManagerID: this.state.salesManagerID,
            payment_term_id: this.state.payment_term_id,
            activateQuantity: this.state.activateQuantity,
          };
          this.props.clone_contract(postData);
        } else if (
          contractIdParams !== "" &&
          contractTypeParams == "clone-non-execeuted"
        ) {
          const postData = {
            cloneContractID: this.state.contractID,
            proposal_type: this.state.contractType,
            affiliatePurchaseUrl: this.state.affiliatePurchaseUrl,
            paymentType: this.state.paymentType,
            paymentAmount: this.state.paymentAmount,
            paymentReceived: this.state.paymentReceived,
            paymentAmountReceived: this.state.paymentAmountReceived,
            service: this.state.service,
            price: this.state.pricing,
            creditCardType: this.state.creditCardType,
            creditCardNumber: this.state.creditCardNumber,
            cardExpirationDate: this.state.cardExpirationDate,
            securityNumber: this.state.securityNumber,
            cityID: this.state.cityID,
            merchantOffer: this.state.merchantOffer,
            detail: additionalPrice,
            merchantID: this.state.merchantID,
            merchantLegalName: this.state.merchantLegalName,
            address1: this.state.address1,
            address2: this.state.address2,
            city: this.state.city ? this.state.city : "",
            state: this.state.state ? this.state.state : "",
            country: this.state.country ? this.state.country : "",
            addState: this.state.addState ? this.state.addState : "",
            addCity: this.state.addCity ? this.state.addCity : "",
            zip: this.state.zip,
            phone: this.state.phone,
            contactName: this.state.contactName,
            contactPhone: this.state.contactPhone,
            contactEmail: this.state.contactEmail,
            notes: this.state.notes,
            termsAndConditions: this.state.termsAndConditions,
            french_termsAndConditions: this.state.french_termsAndConditions,
            redeemedAtCall: this.state.redeemedAtCall,
            shipable: this.state.shipable,
            redemptionCodeReq: this.state.redemptionCodeReq,
            vouchersBeIssued: this.state.vouchersBeIssued,
            salesManagerID: this.state.salesManagerID,
            payment_term_id: this.state.payment_term_id,
            activateQuantity: this.state.activateQuantity,
          };
          this.props.clone_contract_non_executed(postData);
        }
      } else {
        const postData = {
          proposal_type: this.state.contractType,
          affiliatePurchaseUrl: this.state.affiliatePurchaseUrl,
          paymentType: this.state.paymentType,
          paymentAmount: this.state.paymentAmount,
          paymentReceived: this.state.paymentReceived,
          paymentAmountReceived: this.state.paymentAmountReceived,
          service: this.state.service,
          price: this.state.pricing,
          creditCardType: this.state.creditCardType,
          creditCardNumber: this.state.creditCardNumber,
          cardExpirationDate: this.state.cardExpirationDate,
          securityNumber: this.state.securityNumber,
          cityID: this.state.cityID,
          merchantOffer: this.state.merchantOffer,
          detail: additionalPrice,
          merchantID: this.state.merchantID,
          merchantLegalName: this.state.merchantLegalName,
          address1: this.state.address1,
          address2: this.state.address2,
          city: this.state.city ? this.state.city : "",
          state: this.state.state ? this.state.state : "",
          country: this.state.country ? this.state.country : "",
          addState: this.state.addState ? this.state.addState : "",
          addCity: this.state.addCity ? this.state.addCity : "",
          zip: this.state.zip,
          phone: this.state.phone,
          contactName: this.state.contactName,
          contactPhone: this.state.contactPhone,
          contactEmail: this.state.contactEmail,
          notes: this.state.notes,
          termsAndConditions: this.state.termsAndConditions,
          french_termsAndConditions: this.state.french_termsAndConditions,
          redeemedAtCall: this.state.redeemedAtCall,
          shipable: this.state.shipable,
          redemptionCodeReq: this.state.redemptionCodeReq,
          vouchersBeIssued: this.state.vouchersBeIssued,
          salesManagerID: this.state.salesManagerID,
          payment_term_id: this.state.payment_term_id,
          activateQuantity: this.state.activateQuantity,
        };
        this.props.add_contract(postData);
      }
    } else {
      let arr = Object.values(yCoordinate);
      let min = Math.min(...arr);
      let yCoordinateKey = "",
        yCoordinateValue,
        xCoordinateValue;
      {
        Object.keys(yCoordinate).map((key) => {
          if (yCoordinate[key] === min && yCoordinateKey.length == 0) {
            yCoordinateValue = yCoordinate[key];
            yCoordinateKey = key;
          }
        });
      }
      if (yCoordinateKey.length > 0) {
        xCoordinateValue = xCoordinate[yCoordinateKey];
      }
    }
  }

  Clear() {
    (this.state.contractType = "1"),
      (this.state.affiliatePurchaseUrl = ""),
      (this.state.paymentType = ""),
      (this.state.paymentAmount = ""),
      (this.state.paymentReceived = ""),
      (this.state.paymentAmountReceived = ""),
      (this.state.service = ""),
      (this.state.pricing = ""),
      (this.state.creditCardType = ""),
      (this.state.creditCardNumber = ""),
      (this.state.cardExpirationDate = ""),
      (this.state.securityNumber = ""),
      (this.state.cityID = ""),
      (this.state.merchantID = ""),
      (this.state.merchantLegalName = ""),
      (this.state.address1 = ""),
      (this.state.address2 = ""),
      (this.state.addState = ""),
      (this.state.addCity = ""),
      (this.state.zip = ""),
      (this.state.phone = ""),
      (this.state.contactName = ""),
      (this.state.contactPhone = ""),
      (this.state.contactEmail = ""),
      (this.state.notes = ""),
      (this.state.termsAndConditions = ""),
      (this.state.french_termsAndConditions = ""),
      (this.state.redeemedAtCall = ""),
      (this.state.shipable = ""),
      (this.state.redemptionCodeReq = ""),
      (this.state.vouchersBeIssued = "");
    (this.state.merchantOffer = ""),
      (this.state.offerTitle = ""),
      (this.state.french_offerTitle = ""),
      (this.state.percentageOff = ""),
      (this.state.maxAvailable = ""),
      (this.state.retailPrice = ""),
      (this.state.offerPrice = ""),
      (this.state.remittance = ""),
      (this.state.maxPerCustomer = ""),
      (this.state.maxAsGift = ""),
      (this.state.incrementalRedemption = ""),
      (this.state.expirationMonth = ""),
      (this.state.startDate = ""),
      (this.state.minQuantity = ""),
      (this.state.activateQuantity = ""),
      (this.state.skuCode = ""),
      (this.state.contract = ""),
      (this.state.salesManagerID = ""),
      this.setState({ attributes: "" }),
      (attributeData = []);

    additionalPriceDetail = [];
    priceIndex = 0;
    priceIndex = [];
    offerTitle = [];
    french_offerTitle = [];
    expirationMonth = [];
    expirationDate = [];
    minQuantity = [];
    activateQuantity = [];
    skuCode = [];
    maxPerCustomer = [];
    percentageOff = [];
    maxAvailable = [];
    retailPrice = [];
    offerPrice = [];
    remittance = [];
    incrementalRedemption = [];
    maxAsGift = [];
    RecurringBillingCycle = [];
    RecurringofferPrice = [];
    RecurringretailPrice = [];
    Days = [];
    BillingPeriodOptions = [];
    form = [];
    this.state.priceIndex = [];
  }

  onSelectedCountry = () => (evt) => {
    this.setState({ disabled: false });
    const selectedCountry = this.state.countryData.find(
      (k) => k.country == evt.target.value
    );
    this.setState({
      changeCountry: true,
      country: selectedCountry.country,
    });
  };

  // onSelectedCountry = (val, key) => {
  //   this.setState({ disabled: false });
  //   this.setState({ country: val });
  //   if(this.state.country != val){
  //     this.setState({state: '', stateAbbr: '', city: '', cityID: ''});
  //   }
  // };

  // onSelectedState = (val, key) => {
  //   console.log('val',val)
  //   console.log('key',key)
  //   this.setState({ disabled: false });
  //   this.setState({ state: val });
  // };

  onSelectedState = (e) => {
    //console.log("e.target.value", e.target.value);
    const index = e.nativeEvent.target.selectedIndex;
    const selectedStateAbbr = e.target.value;
    const selectedState = e.nativeEvent.target[index].text;
    //console.log("selectedState", selectedState);
    this.setState({
      state: selectedStateAbbr,
      selectedStateAbbr: selectedStateAbbr,
      addState: selectedState,
    });
    if (selectedStateAbbr) {
      this.setState({ stateError: "" });
    } else {
      this.setState({ stateError: "red" });
    }
  };

  onSelectedCity = (val, key) => {
    this.setState({ disabled: false });
    this.setState({ city: val });
    this.setState({ cityID: key });
  };

  handlePageChange = (page) => {
    isLoading = "true";
    contractTypeParams = this.props.match.params.cType
      ? this.props.match.params.cType
      : "";
    contractIdParams = this.props.match.params.contractId
      ? this.props.match.params.contractId
      : "";

    if (contractIdParams !== "" && contractTypeParams == "edit") {
    } else {
      this.props.get_merchant_list({ page: 0 });
    }
  };

  componentDidMount() {
    this.handlePageChange();
    this.props.getAllCountryData();
    this.props.ContractType();
    this.setState({ countryData: this.props.countries });
  }

  componentWillMount() {
    offerTitle = [];
    r_offerTitle = [];
    french_offerTitle = [];

    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));

    if (siteData) {
      if (siteData.multi_lang) {
        this.setState({
          multi_lang: siteData.multi_lang,
        });
      }
      if (siteData.active_cities) {
        this.setState({
          stateList: siteData.active_states,
        });
      }
    }
    priceIndex = 0;
    form = [];
    additionalPriceDetail = [];
    userinfo = auth.getUserInfo();

    this.props.clearAlert();
    this.handleDismiss();
    this.props.getSalesPersons();
    this.props.getPayoutDropdownList();

    contractIdParams = this.props.match.params.contractId
      ? this.props.match.params.contractId
      : "";

    contractTypeParams = this.props.match.params.cType
      ? this.props.match.params.cType
      : "";
    if (this.props.match.params.contractId && this.props.match.params.cType) {
      const editLink = `addContract/${this.props.match.params.contractId}/${this.props.match.params.cType}`;
      const path = ["Home", "Manage Contract", "Edit Offer"];
      const links = ["home", "contractList", editLink];
      this.setState({ path: path, links: links });
    }
    if (contractIdParams !== "" && contractTypeParams == "edit") {
      isLoading = "true";
      this.props.getContractDetails(contractIdParams);
    } else if (contractIdParams !== "" && contractTypeParams == "clone") {
      isLoading = "true";
      this.props.getContractDetails(contractIdParams);
    } else if (
      contractIdParams !== "" &&
      contractTypeParams == "clone-non-execeuted"
    ) {
      isLoading = "true";
      this.props.getContractDetails(contractIdParams);
    } else {
      this.setState({ merchantID: contractIdParams });
      this.props.get_merchant_details_id({ merchantId: contractIdParams });
    }
  }

  componentWillReceiveProps(nextProps) {
    let menuAclKey = this.state.menuKey;
    if (this.props.match.params.cType == "edit") {
      menuAclKey = "EDIT_CONTRACT";
    }
    if (!aclUtil.isPrimaryMenuAccessible(menuAclKey)) {
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.countries !== nextProps.countries) {
      this.setState({ countryData: nextProps.countries });
    }

    if (nextProps.ProposalType && this.props.ProposalType !== nextProps.ProposalType) {
      this.setState({ ProposalTypes: nextProps.ProposalType.proposaltype });
    }

    if (this.props.merchantDetails !== nextProps.merchantDetails) {
      if (nextProps.merchantDetails) {
        isLoading = "false";
        const contactNameConst = `${nextProps.merchantDetails.firstName} ${nextProps.merchantDetails.lastName}`;

        this.setState({
          merchantID: nextProps.merchantDetails.merchant_id,
          merchantLegalName: nextProps.merchantDetails.legalName,
          address1: nextProps.merchantDetails.address1,
          address2: nextProps.merchantDetails.address2,
          phone: nextProps.merchantDetails.phone,
          zip: nextProps.merchantDetails.zipcode,
          city: nextProps.merchantDetails.city,
          country: nextProps.merchantDetails.country,
          cityID: nextProps.merchantDetails.cityID,
          state: nextProps.merchantDetails.state,
          addCity: nextProps.merchantDetails.addCity,
          addState: nextProps.merchantDetails.addState,
          merchantLegalName1: nextProps.merchantDetails.merchantName,
        });
      }
    }

    if (this.props.addContractResponse !== nextProps.addContractResponse) {
      if (nextProps.addContractResponse) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert(
          "success",
          nextProps.addContractResponse.message
        );
        this.setState({ disabled: false });
        isLoading = "false";
        this.state.clearAttributes = true;
        this.onSelectedCountry();
        this.Clear();
      }
      window.scrollTo(0, 0);
    }

    if (this.props.updatedContract !== nextProps.updatedContract) {
      if (nextProps.updatedContract) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.updatedContract.message);
        this.setState({ disabled: false });
        isLoading = "false";
        this.Clear();
        this.state.clearAttributes = true;
        window.scrollTo(0, 0);
      }
    }

    if (this.props.cloneContract !== nextProps.cloneContract) {
      if (nextProps.cloneContract) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.cloneContract.message);
        this.setState({ disabled: false });
        isLoading = "false";
        this.Clear();
        this.state.clearAttributes = true;
        window.scrollTo(0, 0);
      }
    }

    if (
      this.props.cloneContractNonExecuted !== nextProps.cloneContractNonExecuted
    ) {
      if (nextProps.cloneContractNonExecuted) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert(
          "success",
          nextProps.cloneContractNonExecuted.message
        );
        this.setState({ disabled: false });
        isLoading = "false";
        this.Clear();
        this.state.clearAttributes = true;
        window.scrollTo(0, 0);
      }
    }

    if (this.props.merchantList !== nextProps.merchantList) {
      if (nextProps.merchantList) {
        this.setState({ merchantList: nextProps.merchantList });
      }
    }

    if (this.props.merchantListStatus !== nextProps.merchantListStatus) {
      if (nextProps.merchantListStatus) {
        this.setState({ merchantListStatus: nextProps.merchantListStatus });
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        window.scrollTo(0, 0);
        this.setState({ disabled: false });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
      window.scrollTo(0, 0);
    }

    if (
      this.props.salesPersonList !== nextProps.salesPersonList &&
      !isEmpty(nextProps.salesPersonList)
    ) {
      this.setState({ salespersonlist: nextProps.salesPersonList.data.data });
    }

    if (this.props.contractDetails !== nextProps.contractDetails) {
      if (nextProps.contractDetails) {
        priceIndex = [];
        isLoading = "false";
        this.setState({ userDetailsForEdit: nextProps.contractDetails.data });
        let contract = nextProps.contractDetails.data;
        if (contract.proposal_type === "7") {
          this.setState({ affiliateOption: true });
        } else if (contract.proposal_type === "6") {
          this.setState({ coupoOption: true });
        }

        this.setState({ paidcart: nextProps.contractDetails.paidcart });
        const expirationMonthConst =
          contract.expirationMonth === null ? "" : contract.expirationMonth;
        this.setState({
          merchantOffer: contract.merchantOffer,
          expirationDate:
            contract.expirationDate !== null
              ? new Date(
                  moment(contract.expirationDate)
                    .format()
                    .replace(/-/g, "/")
                    .replace(/T.+/, "")
                )
              : "",
          contractID: contract.contractID,
          contractType: contract.proposal_type,
          affiliatePurchaseUrl: contract.affiliatePurchaseUrl,
          paymentType: contract.paymentType,
          paymentAmount: contract.paymentAmount,
          paymentReceived: contract.paymentReceived,
          paymentAmountReceived: contract.paymentAmountReceived,
          service: contract.service,
          pricing: contract.price,
          creditCardType: contract.creditCardType,
          creditCardNumber: contract.creditCardNumber,
          cardExpirationDate: contract.cardExpirationDate,
          securityNumber: contract.securityNumber,
          parentID: contract.parentID,
          offerTitle: contract.offerTitle,
          french_offerTitle: contract.french_offerTitle,
          notes: contract.notes,
          termsAndConditions: contract.termsAndConditions,
          french_termsAndConditions: contract.french_termsAndConditions,
          expirationMonth: expirationMonthConst,
          minQuantity: contract.minQuantity,
          activateQuantity: contract.activateQuantity,
          skuCode: contract.skuCode,
          stockmanage:contract.stockmanage,
          percentageOff: contract.percentageOff,
          maxAvailable: contract.maxAvailable,
          retailPrice: contract.retailPrice,
          offerPrice: contract.offerPrice,
          remittance: contract.remittance,
          maxPerCustomer: contract.maxPerCustomer,
          maxAsGift: contract.maxAsGift,
          incrementalRedemption: contract.incrementalRedemption,
          BillingPeriodOptions: contract.BillingPeriodOptions,
          RecurringretailPrice: contract.RecurringretailPrice,
          RecurringofferPrice: contract.RecurringofferPrice,
          RecurringBillingCycle: contract.RecurringBillingCycle,
          Days: contract.Days,
          vouchers: contract.vouchers,
          merchantID: contract.merchantID,
          merchantLegalName: contract.merchantLegalName,
          address1: contract.address1,
          address2: contract.address2,
          city: contract.city,
          addCity: contract.addCity,
          country: contract.country,
          cityID: contract.cityID,
          state: contract.state,
          addState: contract.addState,
          zip: contract.zip,
          phone: contract.phone,
          contactName: contract.contactName,
          contactEmail: contract.contactEmail,
          contactPhone: contract.contactPhone,
          redeemedAtCall: contract.redeemedAtCall,
          shipable: contract.shipable,
          redemptionCodeReq: contract.redemptionCodeReq,
          vouchersBeIssued: contract.vouchersBeIssued,
          attributes: contract.attribute,
          contract: contract.child_contracts,
          metrix: contract.metrix,
          salesManagerID: contract.salesManagerID,
          payment_term_id: contract.payment_term_id,
          max_overall: contract.max_overall > 0 ? contract.max_overall : "",
          merchantLegalName1: contract.merchantName,
        });
        if (!isEmpty(contract.child_contracts)) {
            this.setState({showoutstock:false});
          offerTitle = [];
          r_offerTitle = [];
          french_offerTitle = [];
          expirationMonth = [];
          expirationDate = [];
          minQuantity = [];
          activateQuantity = [];
          skuCode = [];
          maxPerCustomer = [];
          percentageOff = [];
          maxAvailable = [];
          retailPrice = [];
          offerPrice = [];
          remittance = [];
          incrementalRedemption = [];
          maxAsGift = [];
          BillingPeriodOptions = [];
          RecurringretailPrice = [];
          RecurringofferPrice = [];
          RecurringBillingCycle = [];
          Days = [];
          attributeData = [];
          additionalPriceDetail = [];
          matrixData = [];
          vouchers = [];
          priceIndex = 0;
          form = [];
          additionalPriceDetail = [];
          contract.child_contracts.map((data, index) =>
            this.editPricingDetail(data)
          );
        }

        this.attributeData(contract.attribute, 0);

        if (contract.contractID) {
          this.handleContractIDChange(contract.contractID, 0);
        }
        if (contract.offerTitle) {
          this.handleOfferChange(contract.offerTitle, 0);
        }
        if (contract.french_offerTitle) {
          this.handleFrenchOfferChange(contract.french_offerTitle, 0);
        }
        if (contract.expirationMonth) {
          this.handleexpirationMonthChange(contract.expirationMonth, 0);
        }
        if (contract.expirationDate) {
          this.handleexpirationDateChange(contract.expirationDate, 0);
        }
        if (contract.minQuantity) {
          this.handleminQuantityChange(contract.minQuantity, 0);
        }

        if (contract.activateQuantity) {
          this.handleActiveQuantityChange(contract.activateQuantity, 0);
        }

        if (contract.stockmanage) {
          this.handleskuCodeChange(contract.skuCode, 0);
        }
          if (contract.skuCode) {
          this.handleStockChange(contract.stockmanage, 0);
        }
         if (contract.maxPerCustomer) {
          this.handlemaxPerCustomerChange(contract.maxPerCustomer, 0);
        }
        if (contract.percentageOff) {
          this.handlepercentageOffChange(contract.percentageOff, 0);
        }
        if (contract.maxAvailable) {
          this.handlemaxAvailableChange(contract.maxAvailable, 0);
        }
        if (contract.retailPrice) {
          this.handleretailPriceChange(contract.retailPrice, 0);
        }
        if (contract.offerPrice) {
          this.handleofferPriceChange(contract.offerPrice, 0);
        }
        if (contract.remittance) {
          this.handleremittanceChange(contract.remittance, 0);
        }
        if (contract.incrementalRedemption) {
          this.handleincrementalRedemptionChange(
            contract.incrementalRedemption,
            0
          );
        }
        if (contract.vouchers) {
          this.handleGenerateVoucher(contract.vouchers, 0);
        }
        if (contract.maxAsGift) {
          this.handlemaxAsGiftChange(contract.maxAsGift, 0);
        }
        if (contract.BillingPeriodOptions) {
          this.handleBillingPeriodOptionsChange(
            contract.BillingPeriodOptions,
            0
          );
        }
        if (contract.RecurringretailPrice) {
          this.handleRecurringretailPriceChange(
            contract.RecurringretailPrice,
            0
          );
        }
        if (contract.RecurringofferPrice) {
          this.handleRecurringofferPriceChange(contract.RecurringofferPrice, 0);
        }
        if (contract.RecurringBillingCycle) {
          this.handleRecurringBillingCycleChange(
            contract.RecurringBillingCycle,
            0
          );
        }
        if (contract.Days) {
          this.handleDaysChange(contract.Days, 0);
        }
      }
    }

    if (this.props.payoutList !== nextProps.payoutList) {
      if (nextProps.payoutList) {
        isLoading = "false";
        this.setState({ payoutList: nextProps.payoutList.data });
      }
    }
  }

  getValidationOfferTitle() {
    const length = this.state.offerTitle.length;
    if (length < 2) return "error";
    return null;
  }

  getValidationTermsCondition() {
    if (this.state.termsAndConditions) {
      const length = this.state.termsAndConditions.length;
      if (length < 2) return "error";
    }

    return null;
  }

  getValidationNotes() {
    if (this.state.notes) {
      const length = this.state.notes.length;
      if (length < 2) return "error";
    }

    return null;
  }

  getValidationminQuantity() {
    const length = this.state.minQuantity.length;
    if (length >= 1) return "success";
    else if (length === 0) return "error";
    return null;
  }

  getValidationskuCode() {
    if (this.state.skuCode) {
      const length = this.state.skuCode.length;
      if (length < 2) return "error";
    }

    return null;
  }

  getValidationmaxPerCustomer() {
    if (this.state.maxPerCustomer) {
      const length = this.state.maxPerCustomer.length;
      if (length >= 1) return "success";
      else if (length > 0) return "error";
    }
    return null;
  }

  getValidationmaxAsGift() {
    if (this.state.maxAsGift) {
      const length = this.state.maxAsGift.length;
      if (length >= 1) return "success";
      else if (length > 0) return "error";
    }
    return null;
  }

  getValidationpercentageOff() {
    const length = this.state.percentageOff.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationmaxAvailable() {
    if (this.state.maxAvailable) {
      const length = this.state.maxAvailable.length;
      if (length >= 1) return "success";
      else if (length > 0) return "error";
    }
    return null;
  }

  getValidationretailPrice() {
    const length = this.state.retailPrice.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationofferPrice() {
    const length = this.state.offerPrice.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationremittance() {
    const length = this.state.remittance.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationPhoneState() {
    if (this.state.phone) {
      const length = this.state.phone.length;
      if (length !== 0) {
        let mobilepattern = new RegExp(/^\d{3}-\d{3}-\d{4}$/i);
        if (!mobilepattern.test(this.state.phone)) {
          return "error";
        }
      }
    }

    return null;
  }

  getValidationmerchantID() {
    const length = this.state.merchantID.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }
  getValidationcreditCardType() {
    const length = this.state.creditCardType.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationcreditCardNumber() {
    if (this.state.creditCardNumber) {
      const length = this.state.creditCardNumber.length;
      if (length < 16) return "error";
    }

    return null;
  }

  getValidationcardExpirationDate() {
    if (this.state.cardExpirationDate) {
      const length = this.state.cardExpirationDate.length;
      if (length < 4) return "errror";
    }

    return null;
  }

  getValidationsecurityNumber() {
    if (this.state.securityNumber) {
      const length = this.state.securityNumber.length;
      if (length < 3) return "warning";
    }

    return null;
  }

  render() {
    let contract =
      this.props.contractDetails && this.props.contractDetails.merchantLegalName
        ? this.props.contractDetails
        : {};

    let merchantListStatusData =
      contractTypeParams != "edit" ? this.state.merchantListStatus : "success";

    //console.log(merchantListStatusData);

   // console.log("contractTypeParams" + contractTypeParams);

    let merchantListData = this.state.merchantList
      ? this.state.merchantList
      : [];

    let merchantListItem;

    let countrydata = this.state.countryData ? this.state.countryData : [];
    let countryItems, stateItems, cityItems;

    //console.log("akash"+this.state.path);
    let pathCheck = "";
    if (this.state.path == "Home,Manage Contract,Edit Offer") {
      //console.log("ok");
      pathCheck = "merchantListAddContract";
    } else {
      //console.log("fail");
      pathCheck = "merchantListAddContractNormal";
    }

    if (countrydata) {
      countryItems = countrydata.map((countryObject, phyidx) => (
        <option key={phyidx} value={countryObject.country}>
          {countryObject.countryName}
        </option>
      ));
    }

    let salesManagerItems;
    let salespersonData = this.state.salespersonlist
      ? this.state.salespersonlist
      : "";
    if (salespersonData !== "") {
      salesManagerItems = salespersonData.map((salesObject, index) => (
        <option key={index} value={salesObject.user_id}>
          {salesObject.userName}
        </option>
      ));
    }

    let remittancePercentage;
    if (this.state.offerPrice != "") {
      remittancePercentage = parseFloat(
        (this.state.offerPrice > 0
          ? (this.state.offerPrice - this.state.remittance) /
            this.state.offerPrice
          : 0) * 100
      ).toFixed(2);
    } else {
      remittancePercentage = "0.00";
    }

    return (
      <div className="col-lg-12 add-sub-admin">
        {this.props.sendingMerchantDetails ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <form>
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent
                path={this.state.path}
                links={this.state.links}
                context={this.context}
              />
            </div>
          </div>
          {/**start merchant information **/}
          <div className="panel">
            <header className="panel-heading">Merchant Information</header>
            <div className="panel-body">
              {isLoading == "true" || merchantListStatusData != "success" ? (
                <div className="loader">
                  <p className="loading-message">
                    <i>Loading...</i>
                  </p>
                  <div className="spinner">
                    <div className="dot1" />
                    <div className="dot2" />
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={4} xs={12}>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Merchant Name
                    </ControlLabel>

                    {contractTypeParams != "edit" &&
                    pathCheck != "merchantListAddContract" ? (
                      <FormGroup
                        controlId="formMerchantID"
                        validationState={this.getValidationmerchantID()}
                      >
                        <FormControl
                          componentClass="select"
                          name="merchantID"
                          onChange={this.handleChangeMerchant}
                          value={this.state.merchantID}
                          style={{ borderColor: this.state.merchantIDError }}
                        >
                          <option value="">Choose Merchant Name</option>
                          {merchantListData.map((el, key) => {
                            return (
                              <option key={key} value={el.merchantID}>
                                {el.merchantName}
                              </option>
                            );
                          })}
                        </FormControl>
                      </FormGroup>
                    ) : (
                      <FormGroup controlId="formMerchantLegalName1">
                        <FormControl
                          type="text"
                          value={this.state.merchantLegalName1}
                          placeholder="Minimum Legal Name"
                          onChange={this.handleChange}
                          name="merchantLegalName1"
                          style={{
                            borderColor: this.state.merchantLegalNameError,
                          }}
                          readOnly
                        />
                      </FormGroup>
                    )}

                    <FormGroup controlId="formMerchantLegalName">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Merchant Legal
                        Name
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.merchantLegalName}
                        placeholder="Minimum Legal Name"
                        onChange={this.handleChange}
                        name="merchantLegalName"
                        style={{
                          borderColor: this.state.merchantLegalNameError,
                        }}
                      />
                    </FormGroup>
                    <FormGroup controlId="formAddress1">
                      <ControlLabel>Address 1</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.address1}
                        placeholder="Address 1"
                        onChange={this.handleChange}
                        name="address1"
                      />
                    </FormGroup>
                    <FormGroup controlId="formAddress2">
                      <ControlLabel>Address 2</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.address2}
                        placeholder="Address 2"
                        onChange={this.handleChange}
                        name="address2"
                      />
                    </FormGroup>
                  </Col>

                  <Col md={4} xs={12}>
                    <div className="form-group" id="primaryContactInfoCountry">
                      <label htmlFor="country">
                        <span style={{ color: "red" }}>*</span> Country
                      </label>
                      <select
                        name="Country"
                        className="form-control"
                        style={{ borderColor: this.state.countryError }}
                        value={this.state.country}
                        onChange={this.onSelectedCountry()}
                      >
                        <option key="select default">Select a country</option>
                        {countryItems}
                      </select>
                    </div>
                    <FormGroup controlId="formBasicAddStateText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span>State
                      </ControlLabel>
                      <FormControl
                        componentClass="select"
                        value={this.state.state}
                        name="addState"
                        onChange={this.onSelectedState}
                        style={{
                          borderColor: this.state.stateError,
                        }}
                      >
                        <option value="">Choose State</option>
                        {this.state.stateList &&
                          this.state.stateList.map((data, i) => (
                            <optgroup key={i} label={data.country}>
                              {data.states &&
                                data.states.map((states, index) => (
                                  <option key={index} value={states.stateAbbr}>
                                    {states.state}
                                  </option>
                                ))}
                            </optgroup>
                          ))}
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formBasicAddCityText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span>City
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.addCity}
                        placeholder="Enter City"
                        onChange={this.handleChange}
                        style={{ borderColor: this.state.addCityError }}
                        name="addCity"
                      />
                    </FormGroup>
                    <FormGroup controlId="formZipCode">
                      <ControlLabel>Zip Code</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.zip}
                        placeholder="Zip Code"
                        onChange={this.handleChange}
                        name="zip"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <ControlLabel>
                      Phone Number (format: xxx-xxx-xxxx)
                    </ControlLabel>
                    <FormGroup
                      controlId="formPhoneNunber"
                      validationState={this.getValidationPhoneState()}
                    >
                      <NumberFormat
                        format="###-###-####"
                        mask="_"
                        className="form-control"
                        name="phone"
                        placeholder="Enter Phone Number"
                        value={this.state.phone}
                        onChange={this.handleChange}
                      />
                    </FormGroup>
                    <FormGroup controlId="formContactName">
                      <ControlLabel>Contact Name</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.contactName}
                        placeholder="Contact Name"
                        onChange={this.handleChange}
                        name="contactName"
                      />
                    </FormGroup>
                    <FormGroup controlId="formContactPhone">
                      <ControlLabel>Contact Phone</ControlLabel>
                      <NumberFormat
                        format="###-###-####"
                        mask="_"
                        className="form-control"
                        name="contactPhone"
                        placeholder="Contact Phone"
                        value={this.state.contactPhone}
                        onChange={this.handleChange}
                      />
                    </FormGroup>
                    <FormGroup controlId="formContactEmail">
                      <ControlLabel>Contact Email</ControlLabel>
                      <FormControl
                        type="email"
                        value={this.state.contactEmail}
                        placeholder="Contact Email"
                        onChange={this.handleChange}
                        name="contactEmail"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {/**end merchant information **/}

          {/**start contract information **/}
          <div className="panel">
            <header className="panel-heading">Offer Detail</header>
            {this.state.show && this.state.alertMessage !== "" && (
              <div className="col-lg-12">
                <Alert
                  bsStyle={this.state.msgType}
                  onDismiss={this.handleDismiss}
                >
                  <strong>{this.state.msgType}:</strong>{" "}
                  {this.state.alertMessage}
                </Alert>
              </div>
            )}
            <div className="panel-body">
              {isLoading == "true" ? (
                <div className="loader">
                  <p className="loading-message">
                    <i>Loading...</i>
                  </p>
                  <div className="spinner">
                    <div className="dot1" />
                    <div className="dot2" />
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={4} xs={12}>
                    <FormGroup controlId="formParentID">
                      <ControlLabel>Contract/Proposal Type</ControlLabel>
                      <FormControl
                        componentClass="select"
                        style={{ borderColor: this.state.contractTypeError }}
                        name="contractType"
                        defaultValue={this.state.contractType}
                        onChange={this.handleChangeContract}
                        placeholder="select"
                        value={this.state.contractType}
                      >
                        {this.state.ProposalTypes.indexOf(1) !== -1 && (
                          <option value="1">Standard Merchant</option>
                        )}
                        {this.state.ProposalTypes.indexOf(2) !== -1 && (
                          <option value="2">Premium Merchant</option>
                        )}
                        {this.state.ProposalTypes.indexOf(3) !== -1 && (
                          <option value="3">Products</option>
                        )}
                        {this.state.ProposalTypes.indexOf(4) !== -1 && (
                          <option value="4">Travel</option>
                        )}
                        {this.state.ProposalTypes.indexOf(5) !== -1 && (
                          <option value="5">Events</option>
                        )}
                        {this.state.ProposalTypes.indexOf(6) !== -1 && (
                          <option value="6">Coupon Offer</option>
                        )}
                        {this.state.ProposalTypes.indexOf(7) !== -1 && (
                          <option value="7">Affiliate Offer</option>
                        )}
                        {this.state.ProposalTypes.indexOf(8) !== -1 && (
                          <option value="8">Gift Card Vouchers</option>
                        )}
                        {this.state.ProposalTypes.indexOf(9) !== -1 && (
                          <option value="9">Recurring Billing</option>
                        )}
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <FormGroup controlId="formmerchantTitle">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Title
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.merchantOffer}
                        placeholder="Title"
                        onChange={this.handleChange}
                        name="merchantOffer"
                        style={{ borderColor: this.state.merchantOfferError }}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <FormGroup controlId="formmerchantOverall">
                      <ControlLabel>Overall Quantity</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.max_overall}
                        placeholder="Overall Quantity"
                        onChange={this.handleChange}
                        name="max_overall"
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <ControlLabel>Terms and Conditions</ControlLabel>
                    <FormGroup controlId="formTermsAndConditions">
                      <FormControl
                        style={{
                          borderColor: this.state.termsAndConditionsError,
                        }}
                        value={this.state.termsAndConditions}
                        componentClass="textarea"
                        onChange={this.handleChange}
                        name="termsAndConditions"
                        placeholder="Terms and Conditions"
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                  </Col>
                  {this.state.multi_lang == "yes" && (
                    <Col md={4} xs={12}>
                      <ControlLabel>
                        Terms and Conditions (Canadian French)
                      </ControlLabel>
                      <FormGroup controlId="formfrench_termsAndConditions">
                        <FormControl
                          value={this.state.french_termsAndConditions}
                          componentClass="textarea"
                          onChange={this.handleChange}
                          name="french_termsAndConditions"
                          placeholder="Terms and Conditions"
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          </div>
          {/**end contract information **/}

          {/**start contract price information **/}
          <div className="panel">
            <header className="panel-heading">
              Pricing Detail{" "}
              {this.state.affiliateOption == false ? (
                <Button
                  bsSize="small"
                  onClick={this.addPricingDetail}
                  bsStyle="success"
                  className="pull-right"
                >
                  Add Additional Price
                </Button>
              ) : null}
            </header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formOfferTitle">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Offer Title
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.offerTitle}
                        placeholder="Offer Title"
                        onChange={this.handleChangeAditionalPrice}
                        name="offerTitle"
                        style={{ borderColor: this.state.offerTitleError }}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    {this.state.multi_lang == "yes" && (
                      <FormGroup controlId="formfrench_OfferTitle">
                        <ControlLabel>
                          <span style={{ color: "red" }}>*</span> Offer Title
                          (Canadian French)
                        </ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.french_offerTitle}
                          placeholder="Offer Title"
                          onChange={this.handleChangeAditionalPrice}
                          name="french_offerTitle"
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    )}
                    <FormGroup controlId="formExpirationMonth">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> How Long Until
                        Purchased Vouchers Expire?
                      </ControlLabel>
                      <FormControl
                        componentClass="select"
                        style={{ borderColor: this.state.expirationMonthError }}
                        name="expirationMonth"
                        onChange={this.handleChangeAditionalPrice}
                        value={this.state.expirationMonth}
                        disabled={
                          this.state.expirationDate === "" ||
                          this.state.expirationDate === null
                            ? false
                            : true
                        }
                        key={Math.random()}
                      >
                        <option value="">None</option>
                        <option value="1">1 Months</option>
                        <option value="2">2 Months</option>
                        <option value="3">3 Months</option>
                        <option value="4">4 Months</option>
                        <option value="5">5 Months</option>
                        <option value="6">6 Months</option>
                        <option value="7">7 Months</option>
                        <option value="8">8 Months</option>
                        <option value="9">9 Months</option>
                        <option value="10">10 Months</option>
                        <option value="11">11 Months</option>
                        <option value="12">12 Months</option>
                        <option value="18">18 Months</option>
                        <option value="84">7 Years</option>
                        <option value="0">Never Expires</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formExpirationDate">
                      <ControlLabel>or</ControlLabel>
                      <DatePicker
                        onChange={this.onChangeExpirationDate}
                        value={
                          this.state.expirationDate
                            ? this.state.expirationDate
                            : ""
                        }
                        style={{ borderColor: this.state.expirationDateError }}
                        disabled={
                          this.state.expirationMonth === "" ||
                          this.state.expirationMonth === null
                            ? false
                            : true
                        }
                      />
                    </FormGroup>
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        Minimum Quantity Required Per Customer
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formMinQuantity">
                        <FormControl
                          type="text"
                          value={this.state.minQuantity}
                          placeholder="Minimum Quantity Required Per Customer"
                          onChange={this.handleChangeAditionalPrice}
                          name="minQuantity"
                          style={{ borderColor: this.state.minQuantityError }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}

                    {this.state.affiliateOption == false /*false*/ ? (
                      <ControlLabel>
                        Minimum Quantity Required To Activate Offer
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false /*false*/ ? (
                      <FormGroup controlId="formactivateQuantity">
                        <FormControl
                          type="text"
                          value={
                            this.state.contractType == 9
                              ? ""
                              : this.state.activateQuantity
                          }
                          placeholder="Minimum Quantity Required To Activate Offer"
                          onChange={this.handleChangeAditionalPrice}
                          name="activateQuantity"
                          disabled={this.state.contractType == 9 ? true : false}
                          style={{ borderColor: this.state.minQuantityError }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}

                    {this.state.affiliateOption == false ? (
                      <ControlLabel>SKU #</ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup
                        controlId="formSkuCode"
                        validationState={this.getValidationskuCode()}
                      >
                        <FormControl
                          type="text"
                          value={this.state.skuCode}
                          placeholder="SKU Code"
                          onChange={this.handleChangeAditionalPrice}
                          name="skuCode"
                          style={{ borderColor: this.state.skuCodeError }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        Max Per Customer (leave blank for an unlimited amount)
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup
                        controlId="formMaxPerCustomer"
                        validationState={this.getValidationmaxPerCustomer()}
                      >
                        <FormControl
                          type="number"
                          value={this.state.maxPerCustomer}
                          placeholder="Max Per Customer"
                          onChange={this.handleChangeAditionalPrice}
                          name="maxPerCustomer"
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
             {this.state.showoutstock == false ? (
                       <FormGroup controlId="formIncrementalRedemption">
                        <ControlLabel>
                         Manage Stock?
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="stockmanage"
                          onChange={this.handleChangeAditionalPrice}
                          value={this.state.stockmanage}
                        
                        >
                             <option value="1">In Stock</option>
                          <option value="2">Out of Stock</option>
                     
                        </FormControl>
                      </FormGroup>
                           ) : null}

                    {this.state.contractType == "9" ? (
                      <FormGroup controlId="formBillingPeriodOptions">
                        <ControlLabel>Billing Period Options</ControlLabel>
                        <FormControl
                          componentClass="select"
                          value={this.state.BillingPeriodOptions}
                          placeholder="End Recurring Billing after"
                          onChange={this.handleChangeAditionalPrice}
                          name="BillingPeriodOptions"
                          style={{
                            borderColor: this.state.BillingPeriodOptionsError,
                          }}
                        >
                          <option value="Yearly">Yearly</option>
                          <option value="HalfYearly">Half Yearly</option>
                          <option value="Quarterly">Quarterly</option>
                          <option value="Monthly">Monthly</option>
                          <option value="Days">Every Specific Days</option>
                        </FormControl>
                      </FormGroup>
                    ) : null}
                    {this.state.BillingPeriodOptions == "Days" ? (
                      <FormGroup controlId="formDays">
                        <ControlLabel>
                          <span style={{ color: "red" }}>*</span>Specific Days
                        </ControlLabel>
                        <FormControl
                          type="number"
                          value={this.state.Days}
                          placeholder="Specific Days"
                          onChange={this.handleChangeAditionalPrice}
                          name="Days"
                          style={{ borderColor: this.state.DaysError }}
                        />
                      </FormGroup>
                    ) : null}
                  </Col>
                  <Col md={6} xs={12}>
                    {this.state.affiliateOption == true ? (
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Percentage Off
                        (Input 0-100)
                        {this.state.hideMsg == true ? (
                          <span style={{ color: "red" }}>
                            {this.state.limitMessage}
                          </span>
                        ) : null}
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == true ? (
                      <FormGroup controlId="formPercentageOff">
                        <FormControl
                          type="number"
                          value={this.state.percentageOff}
                          placeholder="Percentage Off"
                          onChange={this.handleChangeAditionalPrice}
                          name="percentageOff"
                          style={{ borderColor: this.state.percentageOffError }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Maximum Available
                    </ControlLabel>
                    <FormGroup controlId="formMaxAvailable">
                      <FormControl
                        type="number"
                        value={this.state.maxAvailable}
                        placeholder="Maximum Available"
                        onChange={this.handleChangeAditionalPrice}
                        name="maxAvailable"
                        style={{ borderColor: this.state.maxAvailableError }}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span>
                      {this.state.contractType == "9" ? "Initial" : ""} Retail
                      Price
                    </ControlLabel>
                    <FormGroup controlId="formRetailPrice">
                      <FormControl
                        type="number"
                        value={this.state.retailPrice}
                        placeholder={
                          this.state.contractType == "9"
                            ? "Initial Retail Price"
                            : "Retail Price"
                        }
                        onChange={this.handleChangeAditionalPrice}
                        name="retailPrice"
                        style={{ borderColor: this.state.retailPriceError }}
                        readOnly={
                          this.state.affiliateOption == false ? false : true
                        }
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span>{" "}
                      {this.state.contractType == "9" ? "Initial" : ""} Offer
                      Price
                    </ControlLabel>
                    <FormGroup controlId="formOfferPrice">
                      <FormControl
                        type="number"
                        value={this.state.offerPrice}
                        placeholder={
                          this.state.contractType == "9"
                            ? "Initial Offer Price"
                            : "Offer Price"
                        }
                        onChange={this.handleChangeAditionalPrice}
                        name="offerPrice"
                        style={{ borderColor: this.state.offerPriceError }}
                        readOnly={
                          this.state.affiliateOption == false ? false : true
                        }
                      />
                      <FormControl.Feedback />
                    </FormGroup>

                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Remittance Per
                        Unit (what we pay the merchant) ({remittancePercentage}{" "}
                        % Margin)
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formRemittance">
                        <FormControl
                          type="number"
                          value={this.state.remittance}
                          placeholder="Remittance Per Unit"
                          onChange={this.handleChangeAditionalPrice}
                          name="remittance"
                          style={{ borderColor: this.state.remittanceError }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formIncrementalRedemption">
                        <ControlLabel>
                          Will this offer generate multiple vouchers?
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="incrementalRedemption"
                          onChange={this.handleChangeAditionalPrice}
                          value={this.state.incrementalRedemption}
                          disabled={
                            this.state.paidcart && this.state.paidcart > 0
                              ? true
                              : false
                          }
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>
                    ) : null}
                    {this.state.incrementalRedemption == "1" && (
                      <FormGroup>
                        <ControlLabel>
                          Number of Vouchers to Generate Per Order (each voucher
                          will reflect the retail price divided by the number
                          below. A $25 order / 5 vouchers = $5 value each)
                        </ControlLabel>
                        <FormControl
                          type="number"
                          value={this.state.vouchers}
                          placeholder="Enter Voucher Value"
                          onChange={this.handleChangeAditionalPrice}
                          name="vouchers"
                        />
                      </FormGroup>
                    )}
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Max As Gifts (Do
                        not leave blank. Add 0 for no additional vouchers. No
                        unlimited option)
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup
                        controlId="formMaxAsGift"
                        validationState={this.getValidationmaxAsGift()}
                      >
                        <FormControl
                          type="number"
                          value={this.state.maxAsGift}
                          placeholder="Max As Gifts"
                          onChange={this.handleChangeAditionalPrice}
                          name="maxAsGift"
                          style={{ borderColor: this.state.maxAsGiftError }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}

                    {this.state.contractType == "9" ? (
                      <FormGroup controlId="formRecurringretailPrice">
                        <ControlLabel>
                          <span style={{ color: "red" }}>*</span>Recurring
                          Retail Price
                        </ControlLabel>
                        <FormControl
                          type="number"
                          value={this.state.RecurringretailPrice}
                          placeholder="Recurring Retail Price"
                          onChange={this.handleChangeAditionalPrice}
                          name="RecurringretailPrice"
                          style={{
                            borderColor: this.state.RecurringretailPriceError,
                          }}
                        />
                      </FormGroup>
                    ) : null}

                    {this.state.contractType == "9" ? (
                      <FormGroup controlId="formRecurringofferPrice">
                        <ControlLabel>
                          <span style={{ color: "red" }}>*</span>Recurring Offer
                          Price
                        </ControlLabel>
                        <FormControl
                          type="number"
                          value={this.state.RecurringofferPrice}
                          placeholder="Recurring Offer Price"
                          onChange={this.handleChangeAditionalPrice}
                          name="RecurringofferPrice"
                          style={{
                            borderColor: this.state.RecurringofferPriceError,
                          }}
                        />
                      </FormGroup>
                    ) : null}

                    {this.state.contractType == "9" ? (
                      <FormGroup controlId="formRecurringBillingCycle">
                        <ControlLabel>
                          <span style={{ color: "red" }}>*</span>End Recurring
                          Billing after
                        </ControlLabel>
                        <InputGroup>
                          <FormControl
                            type="number"
                            value={this.state.RecurringBillingCycle}
                            placeholder="End Recurring Billing after"
                            onChange={this.handleChangeAditionalPrice}
                            name="RecurringBillingCycle"
                            style={{
                              borderColor:
                                this.state.RecurringBillingCycleError,
                            }}
                          />
                          <InputGroup.Addon>of billing cycles</InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    ) : null}
                  </Col>
                </Row>

                <Row>
                  <Col md={12} xs={12}>
                    <Attributes
                      indexKey={0}
                      attributeData={this.attributeData}
                      matrixData={this.matrixData}
                      postAttributes={this.state.attributes}
                      postMatrix={this.state.metrix}
                      clearStatus={this.state.clearAttributes}
                      key={Math.random()}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {this.state.priceIndex.map((price, idx) => price)}
          {/**end contract price information **/}

          {/**start contract affiliate information **/}
          {this.state.affiliateOption == true ? (
            <div className="panel">
              <header className="panel-heading">GET ACCESS CONTRACT</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formaffiliatePurchaseUrl">
                        <ControlLabel>Affiliate Purchase URL</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.affiliatePurchaseUrl}
                          name="affiliatePurchaseUrl"
                          placeholder=""
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                      <FormGroup controlId="formpaymentType">
                        <ControlLabel>Payment type</ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="paymentType"
                          onChange={this.handleChange}
                          value={this.state.paymentType}
                        >
                          <option value="Fixed Fee">Fixed Fee</option>
                          <option value="Pay per voucher">
                            Pay Per Voucher
                          </option>
                        </FormControl>
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formpaymentAmount">
                        <ControlLabel>Payment amount</ControlLabel>
                        <FormControl
                          type="number"
                          value={this.state.paymentAmount}
                          placeholder="Amount"
                          onChange={this.handleChange}
                          name="paymentAmount"
                        />
                      </FormGroup>
                      <FormGroup controlId="formpaymentReceived">
                        <ControlLabel>Payment received?</ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="paymentReceived"
                          onChange={this.handlePaymentReceived}
                          value={this.state.paymentReceived}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>
                      {this.state.paymentAmountReceivedStatus === true ? (
                        <FormGroup controlId="formpaymentAmountReceived">
                          <ControlLabel>Payment amount received</ControlLabel>
                          <FormControl
                            type="number"
                            value={this.state.paymentAmountReceived}
                            placeholder="paymentAmountReceived"
                            onChange={this.handleChange}
                            name="paymentAmountReceived"
                          />
                        </FormGroup>
                      ) : null}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : null}
          {/**start contract affiliate information **/}

          {/**start contract coupon information **/}
          {this.state.coupoOption === true ? (
            <div className="panel">
              <header className="panel-heading">Coupon Options</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formService">
                        <ControlLabel>Service</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.service}
                          name="service"
                          placeholder="Service (ex - red, blue)"
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                      <FormGroup controlId="formPricing">
                        <ControlLabel>Pricing</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.pricing}
                          placeholder="Pricing ex - (10, 100)"
                          onChange={this.handleChange}
                          name="pricing"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formCreditCardType">
                        <ControlLabel>
                          Merchant Billing Information
                        </ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formRetailPrice">
                        <ControlLabel>Credit Card Type</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.creditCardType}
                          placeholder="Credit Card Type"
                          onChange={this.handleChange}
                          name="creditCardType"
                          style={{
                            borderColor: this.state.creditCardTypeError,
                          }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                      <ControlLabel>Credit Card Number</ControlLabel>
                      <FormGroup
                        controlId="formCreditCardNumber"
                        validationState={this.getValidationcreditCardNumber()}
                      >
                        <FormControl
                          type="number"
                          value={this.state.creditCardNumber}
                          placeholder="Card Mumber"
                          onChange={this.handleChange}
                          name="creditCardNumber"
                          style={{
                            borderColor: this.state.creditCardNumberError,
                          }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                      <ControlLabel>Expiration Date (MMYY)</ControlLabel>
                      <FormGroup
                        controlId="formCardExpirationDate"
                        validationState={this.getValidationcardExpirationDate()}
                      >
                        <FormControl
                          type="number"
                          value={this.state.cardExpirationDate}
                          placeholder="Expiration Date"
                          onChange={this.handleChange}
                          name="cardExpirationDate"
                          style={{
                            borderColor: this.state.cardExpirationDateError,
                          }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                      <ControlLabel>Security Code</ControlLabel>
                      <FormGroup
                        controlId="formSecurityNumber"
                        validationState={this.getValidationsecurityNumber()}
                      >
                        <FormControl
                          type="number"
                          value={this.state.securityNumber}
                          placeholder="Security Code"
                          onChange={this.handleChange}
                          name="securityNumber"
                          style={{
                            borderColor: this.state.securityNumberError,
                          }}
                          minLength="3"
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : null}
          {/**end contract coupon information **/}

          {/**start additional option **/}
          {this.state.affiliateOption == false ? (
            <div className="panel">
              <header className="panel-heading">Additional Option</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={4} xs={12}>
                      <FormGroup controlId="formRedeemedAtCall">
                        <ControlLabel>
                          {/*Will vouchers be redeemed at will call?*/}
                          Allow this offer to be Gifted?
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="redeemedAtCall"
                          onChange={this.handleChange}
                          value={this.state.redeemedAtCall}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>
                    </Col>
                    <Col md={4} xs={12}>
                      <FormGroup controlId="formShipable">
                        <ControlLabel>
                          Will this offer be shipped to the customer?
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="shipable"
                          onChange={this.handleChange}
                          value={this.state.shipable}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>
                    </Col>
                    <Col md={4} xs={12}>
                      <FormGroup controlId="formPaymentTerms">
                        <ControlLabel>Payment terms</ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="payment_term_id"
                          onChange={this.handleChange}
                          value={this.state.payment_term_id}
                          style={{
                            borderColor: this.state.payment_term_idError,
                          }}
                        >
                          <option value="">Choose Option</option>
                          {this.state.payoutList !== "" &&
                            this.state.payoutList.map((data, index) => (
                              <option key={index} value={data.termID}>
                                {data.termName}
                              </option>
                            ))}
                        </FormControl>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : null}
          {/**end additional option **/}
          <div className="panel">
            <header className="panel-heading">Additional Notes</header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formNotes">
                      <FormControl
                        style={{
                          borderColor: this.state.notesError,
                        }}
                        value={this.state.notes}
                        componentClass="textarea"
                        rows={6}
                        onChange={this.handleChange}
                        name="notes"
                        placeholder="Additonal Notes"
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>

          {userinfo.userTypeName !== "salesmanager" ? (
            <div className="panel">
              <header className="panel-heading">Administrative Option</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={3} xs={12}>
                      <FormGroup controlId="formControlsSelect">
                        <ControlLabel> Sales Person</ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="salesManagerID"
                          value={this.state.salesManagerID}
                          onChange={this.handleChange}
                        >
                          <option>Select Sales Person</option>
                          {salesManagerItems}
                        </FormControl>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button
                bsStyle="info"
                type="submit"
                id="schedule"
                data-key="schedule"
                disabled={this.state.disabled}
                onClick={this.handleSubmit}
              >
                Save
              </Button>
              <Button
                bsStyle="default"
                onClick={() =>
                  this.context.router.history.push(`/contractList`)
                }
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    merchantList: state.merchantReducer.merchantList,
    countries: state.countryCityReducers.countries,
    states: state.countryCityReducers.states,
    cityDetailsByState: state.countryCityReducers.cityDetailsByState,
    contractDetails: state.contractReducer.contractDetail,
    updatedContract: state.contractReducer.updatedContract,
    cloneContract: state.contractReducer.cloneContract,
    cloneContractNonExecuted: state.contractReducer.cloneContractNonExecuted,
    merchantDetails: state.merchantReducer.merchantDetails,
    sendingMerchantDetails: state.merchantReducer.sendingMerchantDetails,
    addContractResponse: state.contractReducer.addContractResponse,
    ProposalType: state.contractReducer.ContractType,
    error: state.contractReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    salesPersonList: state.salesPersonReducer.salesPersonList,
    payoutList: state.payoutReducer.payoutList,
    merchantListStatus: state.merchantReducer.merchantListStatus,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    add_contract,
    get_merchant_list,
    renderAlert,
    clearAlert,
    getContractDetails,
    update_contract,
    clone_contract,
    clone_contract_non_executed,
    get_merchant_details_id,
    getSalesPersons,
    getPayoutDropdownList,
    getAllCountryData,
    ContractType,
  })
)(AddContract);


// WEBPACK FOOTER //
// ./src/app/views/admin/contract/AddContract.js